import {Controller} from "@hotwired/stimulus"
import {loadStripe} from "@stripe/stripe-js";

// Connects to data-controller="stripe"
export default class extends Controller {
  static values = {
    publicKey: String,
    paymentClientSecret: String,
    checkoutClientSecret: String,
    successUrl: String,
    failedUrl: String,
    piStatus: String
  }
  static targets = ["modal", "elementsContainer"]

  async connect() {
    if (window.stripe) {
      this.stripe = window.stripe
    } else {
      this.stripe = await loadStripe(this.publicKeyValue)
      window.stripe = this.stripe
    }
    if (this.hasModalTarget) {
      this.modalTarget.addEventListener("hidden.bs.modal", () => {
        this.disconnect()
      })
    }
    await this.setupElements()
  }

  async setupElements() {
    this.stripeContainer = document.createElement("div")
    this.element.appendChild(this.stripeContainer)

    if (this.piStatusValue === "requires_action" && this.hasPaymentClientSecretValue) {
      // 3DS Flow and other cases where payment intent in requires_action state (Adding items to existing subscription)

      this.paymentElement = this.stripe.handleNextAction({clientSecret: this.paymentClientSecretValue})
        .then((res) => {
          if (res.error) {
            window.location.href = this.failedUrlValue
          } else if (res?.paymentIntent?.status === "succeeded") {
            window.location.href = this.successUrlValue + "?pi=" + res.paymentIntent.id
          }
        })
    } else if (this.hasCheckoutClientSecretValue) {
      // Embedded checkout for new subscription creation

      this.checkout = await this.stripe.initEmbeddedCheckout({
        fetchClientSecret: () => {
          return this.checkoutClientSecretValue
        }
      });
      this.checkout.mount(this.elementsContainerTarget)
    }
  }

  unmountAllElements() {
    if (this.checkout) {
      this.checkout.unmount()
      this.checkout.destroy()
      this.checkout = null
    }
  }

  disconnect() {
    this.unmountAllElements()
    this.element.remove()
  }
}
